const state = {
  navHeaderActive: "首页" //navheader的选择
};

const mutations = {
  UPDATE_NAVHEADERACTIVE: (state, navHeaderActive) => {
    state.navHeaderActive = navHeaderActive;
  },
  UPDATE_CACHENAVHEADER: (state, historyNavheader) => {
    state.historyNavheader = historyNavheader;
  }
};

const actions = {
  updatePasswordDialog({commit}, val) {
    commit("UPDATE_PASS_DIALOG", val);
  }
};

const getters = {
  // navHeaderActive: state => state.navHeaderActive
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/wenxing/store/navHeader.js